<script>
    import { t } from "../../../lang/lang.js";
    import Share from "./Share.svelte";
    import CopyUrl from "./CopyUrl.svelte";
    import Qr from "./Qr.svelte";

    export let qr;
    export let url;
    export let unsupported = false;
</script>

<Share>
    <span slot="title">
        { t('widget.title_size') }
    </span>
    <div slot="left">
        {#if unsupported}
            <div class="arsize_qr_note">
                { t('widget.unsupported_text') }
            </div>
        {:else}
            <div class="arsize_qr_note arsize_qr_note_alert_bgr">
                { t('widget.share_text') }
            </div>
        {/if}
        <Qr {qr} />
    </div>
    <div slot="right">
        <div class="arsize_qr_note">
            { t('widget.share_text') }
        </div>
        <CopyUrl {url} />
    </div>
</Share>

<style>
    .arsize_qr_note {
        font-size: 16px;
        margin-bottom: 34px;
    }
    .arsize_qr_note_alert_bgr {
        padding: 2px 0 0 32px;
        background: transparent url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNCAyNiIgZmlsbD0iI0VCNTc1NyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xIDE0QzEgMjAuMDc1MSA1LjkyNDg3IDI1IDEyIDI1QzE4LjA3NTEgMjUgMjMgMjAuMDc1MSAyMyAxNEMyMyA3LjkyNDg3IDE4LjA3NTEgMyAxMiAzQzUuOTI0ODcgMyAxIDcuOTI0ODcgMSAxNFpNMjEgMTRDMjEgMTguOTcwNiAxNi45NzA2IDIzIDEyIDIzQzcuMDI5NDQgMjMgMyAxOC45NzA2IDMgMTRDMyA5LjAyOTQ0IDcuMDI5NDQgNSAxMiA1QzE2Ljk3MDYgNSAyMSA5LjAyOTQ0IDIxIDE0Wk0xMi4wMDAzIDE5Ljk5ODNDMTIuNTUyOCAxOS45OTgzIDEzLjAwMDcgMTkuNTUwNiAxMy4wMDA3IDE4Ljk5ODNDMTMuMDAwNyAxOC40NDYxIDEyLjU1MjggMTcuOTk4MyAxMi4wMDAzIDE3Ljk5ODNDMTEuNDQ3OSAxNy45OTgzIDExIDE4LjQ0NjEgMTEgMTguOTk4M0MxMSAxOS41NTA2IDExLjQ0NzkgMTkuOTk4MyAxMi4wMDAzIDE5Ljk5ODNaTTEzLjAwMzYgNy45OTgzNUgxMS4wMDNWMTUuOTk4M0gxMy4wMDM2VjcuOTk4MzVaIiBmaWxsPSIjRUI1NzU3Ij48L3BhdGg+Cjwvc3ZnPg==") no-repeat 0 0;
    }
    @media(max-width: 1279.98px) {
        .arsize_qr_note {
            display: block;
            font-size: 12px;
            margin-bottom: 20px;
        }
    }
</style>